module.exports = __webpack_public_path__ + "static/media/backWave20.26500182.svg";